"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimeout = void 0;
const react_1 = require("react");
/**
 * A callback to create a timeout.
 *
 * Handles the impedance mismatch between imperative setTimeout and React's
 * declarative model.
 *
 * @param callback : A function that you wish to delay execution of
 * @param delay : The number of milliseconds to delay
 */
const useTimeout = (callback, delay) => {
    const savedCallback = (0, react_1.useRef)();
    // Keep the latest callback function between renders
    (0, react_1.useEffect)(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Run the timeout
    (0, react_1.useEffect)(() => {
        let timeoutId;
        if (savedCallback.current) {
            timeoutId = setTimeout(() => {
                savedCallback.current();
            }, delay);
        }
        return () => timeoutId && clearTimeout(timeoutId);
    }, [delay]);
};
exports.useTimeout = useTimeout;
//# sourceMappingURL=useTimeout.js.map